import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DataManager } from '@syncfusion/ej2-data';
import { TranslateService } from '@ngx-translate/core';
import { saveAs as importedSaveAs } from "file-saver";
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { NotifyService } from '../../services/notify.service';
import { SidebarService } from '../../sidebar/sidebar.service';
import { AuthenService } from '../../services/authen.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UrlParams } from '../../helpers/url-params';
import { MasterBase } from '../../base/master-base';
import * as AppConst from '../../data/test.data';
import { MyImportFileDialogComponent } from "../../dialogs/my-import-file-dialog/my-import-file-dialog";
import { ChangeEventArgs } from '@syncfusion/ej2-buttons';
import { Util } from '../../helpers/global.util';

@Component({
    selector: '',
    templateUrl: './hs-matrix-v2-search.html',
})
export class HSMatrixV2SearchComponent extends MasterBase implements OnInit, OnDestroy {



    @ViewChild('dlgImport') dlgImport: MyImportFileDialogComponent;
    waiting: boolean = false;
    requestTypeMList: any[] = [];
    requestTypesSelected: string[] = [];
    nameValueFields: Object = { text: 'Name', value: 'Value' };


    groupHSCode: string = "";
    HSCode: string = "";


    constructor(auth: AuthenService, http: HttpService, private route: ActivatedRoute, helper: HelperService, notify: NotifyService, translate: TranslateService, private sidebar: SidebarService, private router: Router) {
        super(auth, http, helper, notify, translate);
        

    }

    ngOnDestroy() {
    }

    ngOnInit() {
        this.onSearch();
        this.searchRequestTypes('');
    }

    onSearch() {
        let params = new UrlParams();
        params.add('groupHScode', this.groupHSCode);
        params.add('hsCode', this.HSCode);
        params.add('requestType', Util.array2String(this.requestTypesSelected));

        this.gridData = this.http.getByManager(`api/HsMatrixV2/GetPageHsMatrixV2?${params.toString()}`, this.auth);
    }

    onExport() {
        let params = new UrlParams();
        params.add('groupHScode', this.groupHSCode);
        params.add('hsCode', this.HSCode);
        params.add('requestType', Util.array2String(this.requestTypesSelected));
        this.waiting = true;
        this.http.download(`api/HsMatrixV2/ExportHSMatrixV2?${params.toString()}`, res => {
            let fileNameExport = 'CRM_HS_Matrix_V2.xlsx';
            importedSaveAs(res, fileNameExport);
            this.waiting = false;
        });
    }

    onImport() {
        debugger;
        this.dlgImport.show('api/HsMatrixV2/ImportHSMatrixV2', null, res => {
            this.grid.refresh();
        });
    }

   

    searchRequestTypes(text: string) {
        this.http.get(`api/Util/SearchAllRequestTypeList?text=${text}`, res => {
            let tempList: any[] = [];
            res.Result.forEach(p => tempList.push({ 'Name': p.Name, 'Value': p.Value }));
            this.requestTypeMList = tempList;
            //console.log(this.requestTypeMList);
        });
    }

    onCheckAllRequestType(evt: ChangeEventArgs) {
        if (evt.checked) {
            this.requestTypesSelected = [];
            this.requestTypeMList.forEach(p => {
                this.requestTypesSelected.push(p.Value);
            });
        } else {
            this.requestTypesSelected = [];
            console.log(this.requestTypesSelected);
        }
        //this.ngRefresh();
    }


    onDelete(id: number) {
        this.helper.confirm('Are you sure you want to remove this item ?', () => {
            this.http.delete(`api/HsMatrixV2/RemoveHSMatrixV2/${id}`, res => {
                this.grid.refresh();
            });
        });
    }

    addNew() {
        this.router.navigate(['/hs-matrix-v2-detail']);
    }



}
